/*
 * Global shipping option gate for quick-add / grid product forms.
 * Requires window.KSShippingOption (ks-shipping-option.js).
 */
(function () {
    "use strict";

    var GATE_ID = "ks-shipping-gate";
    var CANCEL_ERROR = "ks-shipping-gate-cancelled";
    var UPDATED_EVENT = "ks-shipping-option-updated";

    function getKS() {
        return window.KSShippingOption || null;
    }

    function getHost(form) {
        if (!form) return null;
        return form.closest ? form.closest("product-form") : null;
    }

    function formHasSelector(form) {
        if (!form || !form.querySelector) return false;
        return Boolean(form.querySelector("[data-ks-shipping-selector]"));
    }

    function formRequiresShipping(form, host) {
        if (!form) return false;
        if (formHasSelector(form)) return false;

        var root = host || getHost(form) || form;
        var attr = root.dataset ? root.dataset.ksRequiresShipping : "";

        if (attr === "false") return false;
        if (attr === "true") return true;

        return (
            form.getAttribute("data-type") === "add-to-cart-form" ||
            form.dataset.type === "add-to-cart-form"
        );
    }

    function buildResult(shippingValue) {
        var KS = getKS();
        var normalized = KS
            ? KS.normalizeShippingOption(shippingValue || "")
            : String(shippingValue || "").trim();
        var estimatedShipDate = KS
            ? KS.getEstimatedShipDateForOption(normalized)
            : "";
        return {
            shippingValue: normalized,
            estimatedShipDate: estimatedShipDate,
        };
    }

    function applyShippingProperties(formData, result) {
        if (!formData || !result || !result.shippingValue) return formData;
        formData.set("properties[Shipping Option]", result.shippingValue);
        formData.set(
            "properties[Estimated Ship Date]",
            result.estimatedShipDate || ""
        );
        return formData;
    }

    function notifyShippingUpdated(result) {
        try {
            window.dispatchEvent(
                new CustomEvent(UPDATED_EVENT, {
                    detail: result || null,
                })
            );
        } catch (_) {
            /* ignore */
        }
        StatusNotes.refresh();
    }

    function persistSelection(result) {
        var KS = getKS();
        if (!KS || !result || !result.shippingValue) {
            return Promise.resolve(result);
        }

        KS.saveStoredOption(result.shippingValue);

        return KS.syncCartAttribute(result.shippingValue)
            .catch(function () {})
            .then(function () {
                if (typeof KS.syncShippingMarker === "function") {
                    return KS.syncShippingMarker(result.shippingValue).catch(
                        function () {}
                    );
                }
            })
            .then(function () {
                notifyShippingUpdated(result);
                return result;
            });
    }

    function getContextForm(statusEl) {
        if (!statusEl) return null;

        var formId = statusEl.dataset ? statusEl.dataset.ksShippingForm : "";
        if (formId) {
            var linked = document.getElementById(formId);
            if (linked) return getHost(linked) || linked;
        }

        var action = statusEl.closest(".action");
        if (action) {
            var actionForm = action.querySelector("product-form");
            if (actionForm) return actionForm;
        }

        return statusEl.closest("product-form");
    }

    function statusContextRequiresShipping(statusEl) {
        var host = getContextForm(statusEl);
        if (!host) return true;
        if (host.dataset && host.dataset.ksRequiresShipping === "false") {
            return false;
        }
        var form = host.querySelector
            ? host.querySelector('form[data-type="add-to-cart-form"]')
            : null;
        return form ? formRequiresShipping(form, host) : true;
    }

    var StatusNotes = {
        refresh: function () {
            var KS = getKS();
            var hasStored = KS && KS.hasStoredOption();
            var storedValue = hasStored ? KS.getStoredOption() : "";

            document
                .querySelectorAll("[data-ks-shipping-gate-status]")
                .forEach(function (el) {
                    var valueEl = el.querySelector(
                        "[data-ks-shipping-gate-status-value]"
                    );
                    var show =
                        hasStored && statusContextRequiresShipping(el);

                    if (show && valueEl) {
                        valueEl.textContent = storedValue;
                    }

                    el.hidden = !show;
                });
        },

        bind: function () {
            if (document.body.dataset.ksShippingStatusBound === "true") {
                return;
            }
            document.body.dataset.ksShippingStatusBound = "true";

            document.addEventListener("click", function (event) {
                var changeBtn = event.target.closest(
                    "[data-ks-shipping-gate-change]"
                );
                if (!changeBtn) return;

                event.preventDefault();
                openPicker({ trigger: changeBtn });
            });

            window.addEventListener(UPDATED_EVENT, StatusNotes.refresh);
            window.addEventListener("storage", function (event) {
                var KS = getKS();
                if (KS && event.key === KS.STORAGE_KEY) {
                    StatusNotes.refresh();
                }
            });

            document.addEventListener("shopify:section:load", StatusNotes.refresh);
        },

        init: function () {
            StatusNotes.bind();
            StatusNotes.refresh();
        },
    };

    var GateUI = {
        root: null,
        panel: null,
        titleEl: null,
        productEl: null,
        estimateWrap: null,
        estimateValue: null,
        errorEl: null,
        confirmBtn: null,
        selectedValue: "",
        mode: "add",
        resolve: null,
        reject: null,
        previousFocus: null,
        keyHandler: null,

        ensureMounted: function () {
            if (this.root) return;

            var html =
                '<div id="' +
                GATE_ID +
                '" class="ks-shipping-gate" hidden>' +
                '<div class="ks-shipping-gate__backdrop" data-ks-shipping-gate-close tabindex="-1"></div>' +
                '<div class="ks-shipping-gate__panel" role="dialog" aria-modal="true" aria-labelledby="ks-shipping-gate-title">' +
                '<button type="button" class="ks-shipping-gate__close modal__close-button" data-ks-shipping-gate-close aria-label="Close">' +
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close"><use href="#icon-close" /></svg>' +
                "</button>" +
                '<h2 id="ks-shipping-gate-title" class="ks-shipping-gate__title" data-ks-shipping-gate-title>Choose shipping option</h2>' +
                '<p class="ks-shipping-gate__product" data-ks-shipping-gate-product hidden></p>' +
                '<p class="ks-shipping-gate__helper">We ship seafood on Mondays and Tuesdays to protect quality in transit.</p>' +
                '<div class="ks-shipping-gate__options" data-ks-shipping-gate-options role="radiogroup" aria-labelledby="ks-shipping-gate-title"></div>' +
                '<div class="ks-shipping-gate__estimate" data-ks-shipping-gate-estimate-wrap hidden>' +
                '<span class="ks-shipping-gate__estimate-label">Estimated ship date:</span>' +
                '<strong class="ks-shipping-gate__estimate-value" data-ks-shipping-gate-estimate></strong>' +
                "</div>" +
                '<p class="ks-shipping-gate__error" data-ks-shipping-gate-error role="alert" hidden>Please choose a shipping option before adding this item to your cart.</p>' +
                '<div class="ks-shipping-gate__actions">' +
                '<button type="button" class="button button--secondary" data-ks-shipping-gate-cancel>Cancel</button>' +
                '<button type="button" class="button button--primary" data-ks-shipping-gate-confirm data-ks-shipping-gate-confirm-label>Add to cart</button>' +
                "</div>" +
                "</div>" +
                "</div>";

            document.body.insertAdjacentHTML("beforeend", html);

            this.root = document.getElementById(GATE_ID);
            this.panel = this.root.querySelector(".ks-shipping-gate__panel");
            this.titleEl = this.root.querySelector(
                "[data-ks-shipping-gate-title]"
            );
            this.productEl = this.root.querySelector(
                "[data-ks-shipping-gate-product]"
            );
            this.estimateWrap = this.root.querySelector(
                "[data-ks-shipping-gate-estimate-wrap]"
            );
            this.estimateValue = this.root.querySelector(
                "[data-ks-shipping-gate-estimate]"
            );
            this.errorEl = this.root.querySelector(
                "[data-ks-shipping-gate-error]"
            );
            this.confirmBtn = this.root.querySelector(
                "[data-ks-shipping-gate-confirm]"
            );

            var optionsRoot = this.root.querySelector(
                "[data-ks-shipping-gate-options]"
            );
            var KS = getKS();
            var options = KS ? KS.getShippingOptions() : [];

            options.forEach(function (value) {
                var est = KS.getEstimatedShipDateForOption(value);
                var btn = document.createElement("button");
                btn.type = "button";
                btn.className = "ks-shipping-gate__option";
                btn.setAttribute("role", "radio");
                btn.setAttribute("aria-checked", "false");
                btn.dataset.value = value;
                btn.innerHTML =
                    '<span class="ks-shipping-gate__option-label">' +
                    value +
                    "</span>" +
                    '<span class="ks-shipping-gate__option-date">' +
                    est +
                    "</span>";
                optionsRoot.appendChild(btn);
            });

            var self = this;

            this.root.addEventListener("click", function (event) {
                var closeTarget = event.target.closest(
                    "[data-ks-shipping-gate-close], [data-ks-shipping-gate-cancel]"
                );
                if (closeTarget) {
                    event.preventDefault();
                    self.close(false);
                    return;
                }

                var optionBtn = event.target.closest(".ks-shipping-gate__option");
                if (optionBtn) {
                    event.preventDefault();
                    self.selectOption(optionBtn.dataset.value);
                }

                if (event.target.closest("[data-ks-shipping-gate-confirm]")) {
                    event.preventDefault();
                    self.confirm();
                }
            });

            this.keyHandler = function (event) {
                if (!self.root || self.root.hidden) return;
                if (event.code === "Escape") {
                    event.preventDefault();
                    self.close(false);
                }
            };
            document.addEventListener("keydown", this.keyHandler);
        },

        setMode: function (mode) {
            this.mode = mode === "change" ? "change" : "add";

            if (this.titleEl) {
                this.titleEl.textContent =
                    this.mode === "change"
                        ? "Change shipping option"
                        : "Choose shipping option";
            }

            if (this.confirmBtn) {
                this.confirmBtn.textContent =
                    this.mode === "change" ? "Save" : "Add to cart";
            }
        },

        selectOption: function (value) {
            var KS = getKS();
            this.selectedValue = KS
                ? KS.normalizeShippingOption(value || "")
                : String(value || "").trim();

            this.root.querySelectorAll(".ks-shipping-gate__option").forEach(
                function (btn) {
                    var active = btn.dataset.value === this.selectedValue;
                    btn.classList.toggle("is-selected", active);
                    btn.setAttribute("aria-checked", active ? "true" : "false");
                }.bind(this)
            );

            var estimated = KS
                ? KS.getEstimatedShipDateForOption(this.selectedValue)
                : "";
            if (estimated && this.estimateWrap && this.estimateValue) {
                this.estimateValue.textContent = estimated;
                this.estimateWrap.hidden = false;
            } else if (this.estimateWrap) {
                this.estimateWrap.hidden = true;
            }

            if (this.errorEl) this.errorEl.hidden = true;
        },

        open: function (options) {
            var self = this;
            this.ensureMounted();

            return new Promise(function (resolve, reject) {
                self.resolve = resolve;
                self.reject = reject;
                self.previousFocus = options.trigger || document.activeElement;
                self.setMode(options.mode || "add");

                var KS = getKS();
                var initialValue = "";

                if (options.preselectStored && KS && KS.hasStoredOption()) {
                    initialValue = KS.getStoredOption();
                } else if (options.initialValue) {
                    initialValue = options.initialValue;
                }

                self.selectedValue = initialValue;

                if (self.productEl) {
                    if (options.productTitle) {
                        self.productEl.textContent = options.productTitle;
                        self.productEl.hidden = false;
                    } else {
                        self.productEl.textContent = "";
                        self.productEl.hidden = true;
                    }
                }

                self.root.querySelectorAll(".ks-shipping-gate__option").forEach(
                    function (btn) {
                        btn.classList.remove("is-selected");
                        btn.setAttribute("aria-checked", "false");
                    }
                );

                if (initialValue) {
                    self.selectOption(initialValue);
                } else if (self.estimateWrap) {
                    self.estimateWrap.hidden = true;
                }

                if (self.errorEl) self.errorEl.hidden = true;

                self.root.hidden = false;
                document.body.classList.add("ks-shipping-gate-open");

                requestAnimationFrame(function () {
                    self.root.classList.add("is-open");
                    var focusTarget =
                        self.root.querySelector(
                            ".ks-shipping-gate__option.is-selected"
                        ) ||
                        self.root.querySelector(".ks-shipping-gate__option");
                    focusTarget?.focus?.();
                });
            });
        },

        confirm: function () {
            var KS = getKS();
            if (
                !this.selectedValue ||
                (KS && !KS.isValidShippingOption(this.selectedValue))
            ) {
                if (this.errorEl) this.errorEl.hidden = false;
                this.root
                    .querySelector(".ks-shipping-gate__option")
                    ?.focus?.();
                return;
            }

            var self = this;
            var result = buildResult(this.selectedValue);

            persistSelection(result).then(function () {
                self.close(true, result);
            });
        },

        close: function (confirmed, result) {
            if (!this.root) return;

            this.root.classList.remove("is-open");
            document.body.classList.remove("ks-shipping-gate-open");

            var resolve = this.resolve;
            var reject = this.reject;
            var previousFocus = this.previousFocus;

            this.resolve = null;
            this.reject = null;
            this.previousFocus = null;

            setTimeout(
                function () {
                    this.root.hidden = true;
                }.bind(this),
                280
            );

            try {
                previousFocus?.focus?.({ preventScroll: true });
            } catch (_) {
                previousFocus?.focus?.();
            }

            if (confirmed && resolve) {
                resolve(result || buildResult(this.selectedValue));
            } else if (reject) {
                reject(new Error(CANCEL_ERROR));
            }
        },
    };

    function ensureSelection(options) {
        options = options || {};
        var form = options.form;
        var KS = getKS();
        var host = getHost(form);

        if (!form || !KS) {
            return Promise.resolve({ shippingValue: "", estimatedShipDate: "" });
        }

        if (formHasSelector(form)) {
            if (!KS.validate(form)) {
                return Promise.reject(new Error("shipping-not-selected"));
            }
            return Promise.resolve(buildResult(KS.getSelectedOption(form)));
        }

        if (!formRequiresShipping(form, host)) {
            return Promise.resolve({ shippingValue: "", estimatedShipDate: "" });
        }

        if (KS.hasStoredOption()) {
            return Promise.resolve(buildResult(KS.getStoredOption()));
        }

        return GateUI.open({
            mode: "add",
            trigger: options.trigger,
            productTitle:
                options.productTitle || host?.dataset?.ksProductTitle || "",
        });
    }

    function openPicker(options) {
        options = options || {};

        return GateUI.open({
            mode: "change",
            trigger: options.trigger,
            preselectStored: true,
        }).catch(function (err) {
            if (err && err.message === CANCEL_ERROR) {
                return null;
            }
            throw err;
        });
    }

    window.KSShippingGate = {
        CANCEL_ERROR: CANCEL_ERROR,
        UPDATED_EVENT: UPDATED_EVENT,
        formHasSelector: formHasSelector,
        formRequiresShipping: formRequiresShipping,
        requiresShipping: formRequiresShipping,
        ensureSelection: ensureSelection,
        openPicker: openPicker,
        open: openPicker,
        persistSelection: persistSelection,
        applyShippingProperties: applyShippingProperties,
        buildResult: buildResult,
        refreshStatusNotes: StatusNotes.refresh,
    };

    function init() {
        StatusNotes.init();
    }

    if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
    ) {
        init();
    } else {
        document.addEventListener("DOMContentLoaded", init);
    }
})();
